import { FEATURE_FLAGS } from '../../taboola-common-frontend-modules/account-configurations';
import useConfigMatch from '../../taboola-common-frontend-modules/account-configurations/hooks/useConfigMatch';
import { usePermissions } from '../../taboola-common-frontend-modules/authentication/hooks/usePermissions';

export const useMultiLayerDrawerEnabled = () => {
    const isMultiLayerDrawerFFEnabled = useConfigMatch({ [FEATURE_FLAGS.MULTI_LAYER_DRAWER_ENABLED]: 'true' });
    const isMultiLayerDrawerPermissionsEnabled = usePermissions('MULTI_LAYER_DRAWER_ENABLED');
    const isMultiLayerDrawerPermissionsDisabled = usePermissions('MULTI_LAYER_DRAWER_DISABLED');

    return (
        !isMultiLayerDrawerPermissionsDisabled && (isMultiLayerDrawerFFEnabled || isMultiLayerDrawerPermissionsEnabled)
    );
};
